import React from "react";
import {
    Create,
    CreateProps,
    ReferenceArrayInput,
    required,
    SelectArrayInput,
    SimpleForm,
    TextInput
} from "react-admin";
import DisabledHiddenOrganisationIdInput from "../Custom/DisabledHiddenOrganisationIdInput";
import DocumentationLink from "../shared/DocumentationLink";

const RoleCreate = (props: CreateProps) => (
    <>
        <Create title="Create a Role" {...props}>
            <SimpleForm redirect="edit">
                <TextInput source="name" validate={[required()]} />
                <TextInput source="description" validate={[required()]} />
                <DisabledHiddenOrganisationIdInput />
                <ReferenceArrayInput
                    label="Available Tasks"
                    source="availableTasksIds"
                    reference="Task"
                    sort={{ field: "name", order: "ASC" }}
                    perPage={200}
                >
                    <SelectArrayInput optionText="name" />
                </ReferenceArrayInput>
            </SimpleForm>
        </Create>
        <DocumentationLink link="https://docs.google.com/document/d/1ZyKM5svVs8FL6QDxQ59u25tqMiFeugagBzUNKyCMVQQ/edit" />
    </>
);

export default RoleCreate;
